"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleBuilder = void 0;
const ExactValueBuilder_1 = require("./builders/ExactValueBuilder");
const IsInBuilder_1 = require("./builders/IsInBuilder");
const CompositeRuleBuilder_1 = require("./builders/CompositeRuleBuilder");
const RequiredValueBuilder_1 = require("./builders/RequiredValueBuilder");
const LengthRuleBuilder_1 = require("./builders/LengthRuleBuilder");
const MatchesRuleBuilder_1 = require("./builders/MatchesRuleBuilder");
const IsBase64Builder_1 = require("./builders/IsBase64Builder");
const IsValidUrlBuilder_1 = require("./builders/IsValidUrlBuilder");
// tslint:disable-next-line:variable-name
exports.RuleBuilder = {
    exactValue: ExactValueBuilder_1.builder,
    isIn: IsInBuilder_1.builder,
    composite: CompositeRuleBuilder_1.builder,
    required: RequiredValueBuilder_1.builder.required,
    length: LengthRuleBuilder_1.builder,
    matches: MatchesRuleBuilder_1.builder.withPattern,
    isBase64: IsBase64Builder_1.builder,
    isValidUrl: IsValidUrlBuilder_1.builder.isValidUrl,
};
//# sourceMappingURL=RuleBuilder.js.map